import { toast } from "react-toastify";
import { useMutation } from "@tanstack/react-query";
import { AuthType } from "../types/authTypes";
import axios from "axios";

export const useAuthService = () => {
  return useMutation({
    mutationFn: async (postData: AuthType) => {
      try {
        const { data } = await axios.post(
          `${import.meta.env.VITE_API_BASE_URL}/auth/login`,
          // `https://home-deckor-demo.onrender.com/auth/login`,
          postData,
        );
        toast.success("Login successful!");
        localStorage.setItem("token", data.token);
        localStorage.setItem("branchId", data.branchId);
        localStorage.setItem("counterId", data.counterId);
        localStorage.setItem("orgId", data.orgId);
        localStorage.setItem("counterSessionStatus", data.counterSessionStatus);
        localStorage.setItem("role", data.role);
        localStorage.setItem("isCounterOpen", data.isCounterOpen);
        localStorage.setItem("counterSessionStatus", data.counterSessionStatus);
        localStorage.setItem(
          "userName",
          data.username || data.userName || "User",
        );
        localStorage.setItem(
          "username",
          data.username || data.userName || "User",
        );

        return data;
      } catch (error: Error | unknown) {
        if (axios.isAxiosError(error)) {
          toast.error(
            error.response?.data?.message || "An error occurred during login.",
          );
        } else {
          toast.error("An unexpected error occurred.");
        }
        throw error;
      }
    },
  });
};
